(function () {
  'use strict';

  function initialiseGallery(root) {
    var mainItems = Array.prototype.slice.call(root.querySelectorAll('[data-bcu-media-id]'));
    var thumbnails = Array.prototype.slice.call(root.querySelectorAll('[data-bcu-thumbnail]'));
    if (!mainItems.length || !thumbnails.length) return;
    var stage = root.querySelector('[data-bcu-gallery-stage]');
    var previousButton = root.querySelector('[data-bcu-gallery-previous]');
    var nextButton = root.querySelector('[data-bcu-gallery-next]');
    var status = root.querySelector('[data-bcu-gallery-status]');
    var activeIndex = Math.max(0, mainItems.findIndex(function (item) { return !item.hidden; }));

    function selectMedia(mediaId, revealThumbnail) {
      mainItems.forEach(function (item, index) {
        var active = item.getAttribute('data-bcu-media-id') === String(mediaId);
        item.hidden = !active;
        item.setAttribute('aria-hidden', active ? 'false' : 'true');
        if (active) activeIndex = index;
      });
      thumbnails.forEach(function (button) {
        var active = button.getAttribute('data-bcu-thumbnail') === String(mediaId);
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
        if (active && revealThumbnail && button.parentElement) {
          button.parentElement.scrollTo({
            left: button.offsetLeft - (button.parentElement.clientWidth - button.offsetWidth) / 2,
            behavior: 'smooth'
          });
        }
      });
      if (status) status.textContent = 'Bild ' + (activeIndex + 1) + ' von ' + mainItems.length;
    }

    function moveMedia(direction) {
      var nextIndex = (activeIndex + direction + mainItems.length) % mainItems.length;
      selectMedia(mainItems[nextIndex].getAttribute('data-bcu-media-id'), true);
    }

    thumbnails.forEach(function (button) {
      button.addEventListener('click', function () {
        selectMedia(button.getAttribute('data-bcu-thumbnail'), true);
      });
    });
    if (previousButton) previousButton.addEventListener('click', function () { moveMedia(-1); });
    if (nextButton) nextButton.addEventListener('click', function () { moveMedia(1); });

    if (stage) {
      var pointerStartX = null;
      var pointerStartY = null;
      stage.addEventListener('keydown', function (event) {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        moveMedia(event.key === 'ArrowLeft' ? -1 : 1);
      });
      stage.addEventListener('pointerdown', function (event) {
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        pointerStartX = event.clientX;
        pointerStartY = event.clientY;
      });
      stage.addEventListener('pointerup', function (event) {
        if (pointerStartX === null || pointerStartY === null) return;
        var deltaX = event.clientX - pointerStartX;
        var deltaY = event.clientY - pointerStartY;
        pointerStartX = null;
        pointerStartY = null;
        if (Math.abs(deltaX) < 45 || Math.abs(deltaX) <= Math.abs(deltaY)) return;
        moveMedia(deltaX < 0 ? 1 : -1);
      });
      stage.addEventListener('pointercancel', function () {
        pointerStartX = null;
        pointerStartY = null;
      });
      stage.addEventListener('dragstart', function (event) { event.preventDefault(); });
    }

    selectMedia(mainItems[activeIndex].getAttribute('data-bcu-media-id'));
    root.bcuSelectMedia = selectMedia;
  }

  function initialiseProduct(root) {
    var form = root.querySelector('[data-bcu-retail-product-form]');
    if (!form) return;
    var select = form.querySelector('[data-bcu-retail-variant]');
    var optionFields = Array.prototype.slice.call(form.querySelectorAll('[data-bcu-retail-option]'));
    var price = root.querySelector('[data-bcu-retail-price]');
    var compare = root.querySelector('[data-bcu-retail-compare]');
    var addButton = form.querySelector('[data-bcu-retail-add]');
    var availability = root.querySelector('[data-bcu-retail-availability]');

    function updateVariant() {
      if (!select) return;
      var option = select.options[select.selectedIndex];
      var available = Boolean(option && option.getAttribute('data-available') === 'true');
      var mediaId = option && option.getAttribute('data-media-id');
      select.disabled = !option;
      if (price) price.textContent = option ? option.getAttribute('data-price-money') || '' : '—';
      if (compare) {
        compare.textContent = option ? option.getAttribute('data-compare-money') || '' : '';
        compare.hidden = !compare.textContent;
      }
      if (addButton) {
        addButton.disabled = !available;
        addButton.textContent = available ? addButton.getAttribute('data-available-label') : addButton.getAttribute('data-unavailable-label');
      }
      if (availability) {
        availability.textContent = available ? availability.getAttribute('data-available-label') : availability.getAttribute('data-unavailable-label');
        availability.classList.toggle('is-unavailable', !available);
      }
      if (mediaId && root.bcuSelectMedia) root.bcuSelectMedia(mediaId);
    }

    if (select) {
      var variants = Array.prototype.slice.call(select.options);
      function syncOptionFields() {
        var selected = select.options[select.selectedIndex];
        if (!selected || !optionFields.length) return;
        var values = JSON.parse(selected.getAttribute('data-option-values'));
        optionFields.forEach(function (field, index) { field.value = values[index]; });
      }
      syncOptionFields();
      optionFields.forEach(function (field) {
        field.addEventListener('change', function () {
          var values = optionFields.map(function (input) { return input.value; });
          var match = variants.find(function (variant) {
            return variant.getAttribute('data-option-values') === JSON.stringify(values);
          });
          select.value = match ? match.value : '';
          select.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
      select.addEventListener('change', function () {
        syncOptionFields();
        updateVariant();
      });
      if (optionFields.length) {
        form.querySelector('[data-bcu-retail-variant-fallback]').hidden = true;
        form.querySelector('[data-bcu-retail-options]').hidden = false;
      }
    }
    updateVariant();
  }

  function initialiseQuantity(root) {
    root.querySelectorAll('[data-bcu-quantity-control]').forEach(function (control) {
      var input = control.querySelector('input[type="number"]');
      if (!input) return;
      control.querySelectorAll('[data-bcu-quantity-change]').forEach(function (button) {
        button.addEventListener('click', function () {
          var direction = Number(button.getAttribute('data-bcu-quantity-change'));
          var minimum = Number(input.min || 0);
          var maximum = input.max ? Number(input.max) : Infinity;
          var next = Math.min(maximum, Math.max(minimum, Number(input.value || minimum) + direction));
          if (next === Number(input.value)) return;
          input.value = next;
          input.dispatchEvent(new Event('change', { bubbles: true }));
          if (root.matches('[data-bcu-retail-cart]')) {
            var updateButton = root.querySelector('[data-bcu-cart-update]');
            if (updateButton) updateButton.click();
          }
        });
      });
    });
  }

  var retailToastTimer;

  function showRetailToast(message, isError) {
    var toast = document.querySelector('[data-bcu-retail-toast]');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'bcu-retail-toast';
      toast.setAttribute('data-bcu-retail-toast', '');
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      toast.setAttribute('aria-atomic', 'true');
      document.body.appendChild(toast);
    }

    window.clearTimeout(retailToastTimer);
    toast.textContent = message;
    toast.classList.toggle('is-error', Boolean(isError));
    toast.classList.add('is-visible');
    retailToastTimer = window.setTimeout(function () {
      toast.classList.remove('is-visible');
    }, 2000);
  }

  function updateRetailCartCount() {
    var rootPath = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return fetch(rootPath + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) {
        if (!response.ok) throw new Error('cart-read-failed');
        return response.json();
      })
      .then(function (cart) {
        document.querySelectorAll('.sf-cart-count').forEach(function (count) {
          count.textContent = String(cart.item_count);
          count.hidden = false;
        });
        var cartLink = document.querySelector('.bcu-cart-link');
        if (cartLink) {
          cartLink.setAttribute('aria-label', 'Warenkorb, ' + cart.item_count + ' Artikel');
          var customCount = cartLink.querySelector('.bcu-cart-link__count');
          if (!customCount && cart.item_count > 0) {
            customCount = document.createElement('span');
            customCount.className = 'bcu-cart-link__count';
            cartLink.appendChild(customCount);
          }
          if (customCount) {
            customCount.textContent = String(cart.item_count);
            customCount.hidden = cart.item_count === 0;
          }
        }
        document.dispatchEvent(new CustomEvent('bcu:cart-updated', { detail: { cart: cart } }));
        return cart;
      });
  }

  function refreshRetailCart(root) {
    var sectionId = root.getAttribute('data-section-id');
    if (!sectionId) {
      window.location.reload();
      return Promise.resolve();
    }

    var url = new URL(window.location.href);
    url.searchParams.set('section_id', sectionId);
    return fetch(url.toString(), { headers: { Accept: 'text/html' } })
      .then(function (response) {
        if (!response.ok) throw new Error('cart-section-refresh-failed');
        return response.text();
      })
      .then(function (html) {
        var fragment = new DOMParser().parseFromString(html, 'text/html');
        var replacement = fragment.querySelector('[data-bcu-retail-cart]');
        if (!replacement) throw new Error('cart-section-missing');
        root.replaceWith(replacement);
        initialiseCartProperties(replacement);
        initialiseQuantity(replacement);
        initialiseCartRecommendations(replacement);
        initialiseQuickAdd(replacement);
      })
      .catch(function () { window.location.reload(); });
  }

  function initialiseQuickAdd(root) {
    root.querySelectorAll('[data-bcu-quick-add-form]').forEach(function (form) {
      if (form.getAttribute('data-bcu-quick-add-ready') === 'true') return;
      form.setAttribute('data-bcu-quick-add-ready', 'true');
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        var button = form.querySelector('[data-bcu-quick-add-button]');
        var variantInput = form.querySelector('input[name="id"]');
        var variantId = Number(variantInput && variantInput.value);
        if (!button || button.disabled || !variantId) return;

        var isCartRecommendation = form.hasAttribute('data-bcu-cart-quick-add');
        var originalText = button.textContent;
        var originalLabel = button.getAttribute('aria-label');
        button.disabled = true;
        button.classList.add('is-loading');
        button.setAttribute('aria-busy', 'true');

        var rootPath = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        fetch(rootPath + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
        })
          .then(function (response) {
            if (!response.ok) throw new Error('cart-add-failed');
            return response.json();
          })
          .then(function () {
            button.classList.remove('is-loading');
            button.classList.add('is-added');
            button.removeAttribute('aria-busy');
            button.setAttribute('aria-label', 'Zum Warenkorb hinzugefügt');
            if (isCartRecommendation) button.textContent = 'Hinzugefügt';
            showRetailToast('Produkt wurde zum Warenkorb hinzugefügt.');
            return updateRetailCartCount();
          })
          .then(function () {
            if (isCartRecommendation) {
              var cartRoot = form.closest('[data-bcu-retail-cart]');
              if (cartRoot) return refreshRetailCart(cartRoot);
            }
            window.setTimeout(function () {
              button.disabled = false;
              button.classList.remove('is-added');
              if (originalLabel) button.setAttribute('aria-label', originalLabel);
              else button.removeAttribute('aria-label');
              if (isCartRecommendation) button.textContent = originalText;
            }, 1800);
          })
          .catch(function () {
            button.disabled = false;
            button.classList.remove('is-loading');
            button.removeAttribute('aria-busy');
            if (originalLabel) button.setAttribute('aria-label', originalLabel);
            showRetailToast('Das Produkt konnte nicht hinzugefügt werden.', true);
          });
      });
    });
  }

  function initialiseRecommendationSlider(root) {
    var track = root.querySelector('[data-bcu-recommendation-track]');
    if (!track || track.getAttribute('data-bcu-slider-ready') === 'true') return;
    track.setAttribute('data-bcu-slider-ready', 'true');
    var previous = root.querySelector('[data-bcu-recommendation-previous]');
    var next = root.querySelector('[data-bcu-recommendation-next]');
    if (!previous || !next) return;

    function updateControls() {
      var maximum = Math.max(0, track.scrollWidth - track.clientWidth);
      previous.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= maximum - 2;
    }

    function move(direction) {
      track.scrollBy({ left: direction * track.clientWidth, behavior: 'smooth' });
    }

    previous.addEventListener('click', function () { move(-1); });
    next.addEventListener('click', function () { move(1); });
    track.addEventListener('scroll', updateControls, { passive: true });
    window.addEventListener('resize', updateControls);
    updateControls();
  }

  function initialiseSorting(root) {
    root.querySelectorAll('[data-bcu-sort]').forEach(function (select) {
      select.addEventListener('change', function () {
        var url = new URL(window.location.href);
        if (select.value) url.searchParams.set('sort_by', select.value);
        else url.searchParams.delete('sort_by');
        window.location.assign(url.toString());
      });
    });
  }

  function initialiseServiceFilters(root) {
    root.querySelectorAll('[data-bcu-service-collection]').forEach(function (section) {
      var filters = Array.prototype.slice.call(section.querySelectorAll('[data-bcu-service-filter]'));
      var cards = Array.prototype.slice.call(section.querySelectorAll('[data-bcu-service-card]'));
      var resultCount = section.querySelector('[data-bcu-service-result-count]');
      if (!filters.length || !cards.length) return;

      function handlesFor(button) {
        var raw = button.getAttribute('data-handles') || '';
        if (raw === '*') return null;
        return new Set(raw.split(',').map(function (handle) { return handle.trim(); }).filter(Boolean));
      }

      function categoryCount(button) {
        var handles = handlesFor(button);
        if (!handles) return cards.length;
        return cards.filter(function (card) { return handles.has(card.getAttribute('data-product-handle')); }).length;
      }

      filters.forEach(function (button) {
        var count = button.querySelector('[data-bcu-service-filter-count]');
        if (count) count.textContent = String(categoryCount(button));
        button.addEventListener('click', function () {
          var handles = handlesFor(button);
          var categoryKey = button.getAttribute('data-category-key') || '';
          var visibleCount = 0;
          filters.forEach(function (filter) {
            var active = filter === button;
            filter.classList.toggle('is-active', active);
            filter.setAttribute('aria-pressed', active ? 'true' : 'false');
          });
          cards.forEach(function (card) {
            var visible = !handles || handles.has(card.getAttribute('data-product-handle'));
            card.hidden = !visible;
            if (visible) visibleCount += 1;
          });
          if (resultCount) resultCount.textContent = visibleCount + (visibleCount === 1 ? ' Service' : ' Services');
          if (window.history && window.history.replaceState) {
            var currentUrl = new URL(window.location.href);
            if (categoryKey && categoryKey !== 'all') currentUrl.searchParams.set('service_category', categoryKey);
            else currentUrl.searchParams.delete('service_category');
            window.history.replaceState({}, '', currentUrl.toString());
          }
        });
      });

      var requestedCategory = new URL(window.location.href).searchParams.get('service_category');
      if (requestedCategory) {
        var requestedFilter = filters.find(function (button) {
          return button.getAttribute('data-category-key') === requestedCategory;
        });
        if (requestedFilter) requestedFilter.click();
      }
    });
  }

  function initialiseComplementary(root) {
    var container = root.querySelector('[data-bcu-complementary]');
    if (!container || container.getAttribute('data-loaded') === 'true') return;
    var url = container.getAttribute('data-url');
    if (!url) return;
    fetch(url)
      .then(function (response) { return response.text(); })
      .then(function (html) {
        var documentFragment = new DOMParser().parseFromString(html, 'text/html');
        var replacement = documentFragment.querySelector('[data-bcu-complementary]');
        if (!replacement) return;
        container.innerHTML = replacement.innerHTML;
        container.setAttribute('data-loaded', 'true');
        container.hidden = replacement.hidden;
        initialiseQuickAdd(container);
        initialiseRecommendationSlider(container);
      })
      .catch(function () {
        container.hidden = true;
      });
  }

  function initialiseCartRecommendations(root) {
    var container = root.querySelector('[data-bcu-cart-recommendations]');
    if (!container || container.getAttribute('data-loaded') === 'true') return;
    var url = container.getAttribute('data-url');
    if (!url) {
      container.hidden = true;
      return;
    }
    fetch(url)
      .then(function (response) { return response.text(); })
      .then(function (html) {
        var documentFragment = new DOMParser().parseFromString(html, 'text/html');
        var replacement = documentFragment.querySelector('[data-bcu-cart-recommendations]');
        if (!replacement) {
          container.hidden = true;
          return;
        }
        container.innerHTML = replacement.innerHTML;
        container.setAttribute('data-loaded', 'true');
        container.hidden = replacement.hidden;
        initialiseQuickAdd(container);
      })
      .catch(function () {
        container.hidden = true;
      });
  }

  function decodeCartEntities(value) {
    var decoded = String(value == null ? '' : value).trim();
    var entityPattern = /&(#x[0-9a-f]+|#\d+|quot|amp|gt|lt|apos);/gi;
    var namedEntities = { quot: '"', amp: '&', gt: '>', lt: '<', apos: "'" };

    for (var pass = 0; pass < 4; pass += 1) {
      var next = decoded.replace(entityPattern, function (match, entity) {
        var normalised = entity.toLowerCase();
        if (namedEntities[normalised]) return namedEntities[normalised];
        var radix = normalised.indexOf('#x') === 0 ? 16 : 10;
        var number = parseInt(normalised.replace(/^#x?/, ''), radix);
        if (!Number.isFinite(number)) return match;
        try { return String.fromCodePoint(number); } catch (error) { return match; }
      });
      if (next === decoded) break;
      decoded = next;
    }

    return decoded.replace(/\u00a0/g, ' ').replace(/\s+/g, ' ').trim();
  }

  function normaliseCartPropertyLabel(value) {
    var label = decodeCartEntities(value)
      .replace(/^\s*\[?S\d+\]?\s*[:\-–—]?\s*/i, '')
      .replace(/\s*\*+\s*$/, '')
      .replace(/\s+wählen\s*$/i, '')
      .trim();
    return label && !/^S\d+$/i.test(label) ? label : 'Auswahl';
  }

  function formatCartPropertyValue(label, value) {
    var formatted = decodeCartEntities(value);
    if (/^\d{4}-\d{2}-\d{2}$/.test(formatted)) {
      var dateParts = formatted.split('-');
      formatted = dateParts[2] + '.' + dateParts[1] + '.' + dateParts[0];
    }
    if (/uhrzeit/i.test(label) && /^\d{1,2}:\d{2}$/.test(formatted)) formatted += ' Uhr';
    return formatted;
  }

  function parseCartPropertyPairs(rawKey, rawValue) {
    var decodedValue = decodeCartEntities(rawValue);
    var candidate = decodedValue.replace(/\s*=>\s*/g, ':');
    var parsed;

    if (/^\{[\s\S]*\}$/.test(candidate)) {
      try { parsed = JSON.parse(candidate); } catch (error) { parsed = null; }
      if (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) {
        return Object.keys(parsed).map(function (key) {
          var parsedValue = Array.isArray(parsed[key]) ? parsed[key].join(', ') : parsed[key];
          return {
            label: normaliseCartPropertyLabel(key),
            value: formatCartPropertyValue(key, parsedValue),
          };
        });
      }
    }

    var pairs = [];
    var pairPattern = /"([^"]+)"\s*=>\s*"([^"]*)"/g;
    var match;
    while ((match = pairPattern.exec(decodedValue)) !== null) {
      pairs.push({
        label: normaliseCartPropertyLabel(match[1]),
        value: formatCartPropertyValue(match[1], match[2]),
      });
    }
    if (pairs.length) return pairs;

    return [{
      label: normaliseCartPropertyLabel(rawKey),
      value: formatCartPropertyValue(rawKey, decodedValue),
    }];
  }

  function splitCartPropertyValues(label, value) {
    if (!/(zusatzoption|zusatzleistung|extras?|bereiche|leistungen)/i.test(label)) return [value];
    var values = value.split(/\s*,\s*/).filter(Boolean);
    return values.length ? values : [value];
  }

  function extractCartPropertyPrice(value) {
    var pricePattern = /\s*\(?\s*([+−-]?\s*CHF\s*\d[\d'’.,]*(?:\s*(?:–|-))?(?:\s*(?:\/|pro)\s*[^)]+)?)\s*\)?\s*$/i;
    var match = value.match(pricePattern);
    if (!match) return { text: value, price: '' };
    var text = value.slice(0, match.index).replace(/[,(]\s*$/, '').trim();
    return { text: text, price: match[1].replace(/\s+/g, ' ').trim() };
  }

  function createCartPropertyRow(label, value) {
    var row = document.createElement('li');
    var labelElement = document.createElement('span');
    var valueElement = document.createElement('span');

    row.className = 'bcu-retail-cart__meta-row';
    labelElement.className = 'bcu-retail-cart__meta-label';
    labelElement.textContent = label + ':';
    valueElement.className = 'bcu-retail-cart__meta-values';

    splitCartPropertyValues(label, value).forEach(function (part) {
      var line = document.createElement('span');
      var text = document.createElement('span');
      var extracted = extractCartPropertyPrice(part);

      line.className = 'bcu-retail-cart__meta-value';
      text.className = 'bcu-retail-cart__meta-value-text';
      text.textContent = extracted.text || extracted.price;
      line.appendChild(text);

      if (extracted.price && extracted.text) {
        var price = document.createElement('span');
        price.className = 'bcu-retail-cart__meta-price';
        price.textContent = extracted.price;
        line.appendChild(price);
      }
      valueElement.appendChild(line);
    });

    row.appendChild(labelElement);
    row.appendChild(valueElement);
    return row;
  }

  function initialiseCartProperties(root) {
    root.querySelectorAll('[data-bcu-cart-properties]').forEach(function (list) {
      if (list.getAttribute('data-bcu-cart-properties-ready') === 'true') return;
      list.setAttribute('data-bcu-cart-properties-ready', 'true');
      var seen = new Set();

      Array.prototype.slice.call(list.querySelectorAll('[data-bcu-cart-property]')).forEach(function (source) {
        var pairs = parseCartPropertyPairs(
          source.getAttribute('data-bcu-cart-property-key') || '',
          source.getAttribute('data-bcu-cart-property-value') || '',
        );
        var fragment = document.createDocumentFragment();

        pairs.forEach(function (pair) {
          if (!pair.value) return;
          var signature = (pair.label + '\u0000' + pair.value).toLocaleLowerCase('de-CH');
          if (seen.has(signature)) return;
          seen.add(signature);
          fragment.appendChild(createCartPropertyRow(pair.label, pair.value));
        });

        source.parentNode.insertBefore(fragment, source);
        source.remove();
      });
    });
  }

  function initialise(scope) {
    var root = scope || document;
    root.querySelectorAll('[data-bcu-retail-product]').forEach(function (section) {
      initialiseGallery(section);
      initialiseProduct(section);
      initialiseQuantity(section);
      initialiseComplementary(section);
      initialiseQuickAdd(section);
      initialiseRecommendationSlider(section);
    });
    root.querySelectorAll('[data-bcu-retail-cart]').forEach(function (section) {
      initialiseCartProperties(section);
      initialiseQuantity(section);
      initialiseCartRecommendations(section);
      initialiseQuickAdd(section);
    });
    root.querySelectorAll('[data-bcu-retail-collection]').forEach(initialiseSorting);
    initialiseServiceFilters(root);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initialise(document); });
  else initialise(document);
  document.addEventListener('shopify:section:load', function (event) { initialise(event.target); });
})();
